import { FC } from 'react';
import styled from 'styled-components';

import Modal from '@components/modal';
import { PremierText } from '@components/text';
import { MOBILE_SKEW_ANGLE, SKEW_ANGLE } from '@utils/constants';

const Wrapper = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const TextContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: skewX(${SKEW_ANGLE}deg);

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    transform: skewX(${MOBILE_SKEW_ANGLE}deg);
  }
`;

type Props = {
  isShown: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

const ShowInProgressModal: FC<Props> = ({ isShown, onConfirm, onClose }) => {
  return (
    <Modal
      isShown={isShown}
      title='Show is in progress'
      onClose={onClose}
      isActionable
      onConfirm={onConfirm}
    >
      <Wrapper>
        <TextContainer>
          <PremierText>Do you want to exit the current show?</PremierText>
        </TextContainer>
      </Wrapper>
    </Modal>
  );
};

export default ShowInProgressModal;
